const htmlToRtf = require('./app/src/rtf/rtf.class');

export default class HtmlToRtfBrowser extends htmlToRtf {}
